<template>
  <div class="rm-wrapper">

    <!-- ══ HERO ══ -->
    <div class="rm-hero">
      <div class="rm-hero__left">
        <div class="rm-hero__eyebrow">
          <v-icon size="11" color="rgba(255,255,255,0.5)" class="mr-1">mdi-shield-check</v-icon>
          SARPA · Rescue Team Management
        </div>
        <h1 class="rm-hero__title">Rescuer <span class="rm-hero__accent">Directory</span></h1>
        <p class="rm-hero__subtitle">Manage rescue team members, review new applications, track bans and suspensions.</p>
      </div>
      <div class="rm-hero__right">
        <div class="rm-hero__stat">
          <v-icon size="18" color="#4ADE80" class="mb-1">mdi-account-multiple-check</v-icon>
          <div class="rm-hero__stat-val">Active Team</div>
        </div>
      </div>
    </div>

    <!-- ══ TAB NAVIGATION ══ -->
    <div class="rm-tabs-bar">
      <button
        v-for="(tab, i) in tabs"
        :key="i"
        :class="['rm-tab', { 'rm-tab--active': activeTab === i }]"
        @click="activeTab = i"
      >
        <v-icon size="16" class="mr-1" :color="activeTab === i ? '#14532D' : '#94A3B8'">{{ tab.icon }}</v-icon>
        {{ tab.label }}
      </button>
    </div>

    <!-- ══ TAB CONTENT ══ -->
    <div class="rm-content">
      <keep-alive>
        <component :is="currentTabComponent" ref="activeComponent" @rescuerSuspended="handleSuspension" />
      </keep-alive>
    </div>

  </div>
</template>

<script>
import NewRescuers from "../NewRescuers/newList.vue";
import RescuerList from "./alluserlist.vue";
import BannedRescuers from "./bannedList.vue";
import SuspendedRescuers from "./suspendedlist.vue";

export default {
  name: "RescuerManager",
  components: { NewRescuers, RescuerList, BannedRescuers, SuspendedRescuers },
  data() {
    return {
      activeTab: 0,
      tabs: [
        { label: "New Requests",      icon: "mdi-account-plus-outline",  component: "NewRescuers" },
        { label: "Rescuer List",       icon: "mdi-account-group-outline", component: "RescuerList" },
        { label: "Banned Rescuers",    icon: "mdi-account-cancel-outline",component: "BannedRescuers" },
        { label: "Suspended Rescuers", icon: "mdi-account-off-outline",   component: "SuspendedRescuers" },
      ],
    };
  },
  computed: {
    currentTabComponent() {
      return this.tabs[this.activeTab].component;
    },
  },
  watch: {
    activeTab(newTab) {
      if (newTab === 3) {
        this.$nextTick(() => {
          const ref = this.$refs.activeComponent;
          if (ref && ref.getData) ref.getData();
        });
      }
    },
  },
  methods: {
    handleSuspension() {
      const ref = this.$refs.activeComponent;
      if (ref && ref.getData) ref.getData();
    },
  },
};
</script>

<style scoped>
/* ── Wrapper ── */
.rm-wrapper {
  background: #EEF3EC;
  min-height: 100vh;
  font-family: 'Inter', 'poppinsregular', sans-serif;
}

/* ── Hero ── */
.rm-hero {
  background: linear-gradient(135deg, #0A2318 0%, #14532D 55%, #166534 100%);
  padding: 28px 32px 24px;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 16px;
}
.rm-hero__eyebrow {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: rgba(255,255,255,0.45);
  margin-bottom: 8px;
  display: flex;
  align-items: center;
}
.rm-hero__title {
  font-size: 26px;
  font-weight: 800;
  color: #fff;
  margin: 0 0 6px 0;
  line-height: 1.2;
}
.rm-hero__accent { color: #4ADE80; }
.rm-hero__subtitle {
  font-size: 13px;
  color: rgba(255,255,255,0.5);
  font-weight: 400;
  margin: 0;
  max-width: 480px;
}
.rm-hero__right {
  flex-shrink: 0;
}
.rm-hero__stat {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: rgba(255,255,255,0.08);
  border: 1px solid rgba(255,255,255,0.12);
  border-radius: 14px;
  padding: 12px 20px;
}
.rm-hero__stat-val {
  font-size: 12px;
  font-weight: 600;
  color: rgba(255,255,255,0.7);
  margin-top: 2px;
}

/* ── Tabs Bar ── */
.rm-tabs-bar {
  display: flex;
  gap: 4px;
  padding: 16px 24px 0;
  background: #EEF3EC;
  border-bottom: 2px solid rgba(15,23,42,0.08);
}
.rm-tab {
  display: inline-flex;
  align-items: center;
  padding: 10px 18px;
  border-radius: 12px 12px 0 0;
  font-size: 13px;
  font-weight: 600;
  color: #64748B;
  background: transparent;
  border: none;
  cursor: pointer;
  transition: all 0.18s ease;
  letter-spacing: 0.01em;
}
.rm-tab:hover {
  background: rgba(20,83,45,0.07);
  color: #14532D;
}
.rm-tab--active {
  background: #fff;
  color: #14532D;
  box-shadow: 0 -2px 0 #14532D inset, 0 -1px 12px rgba(20,83,45,0.06);
}

/* ── Content ── */
.rm-content {
  background: #fff;
  min-height: 60vh;
}

@media (max-width: 700px) {
  .rm-hero { flex-direction: column; align-items: flex-start; padding: 20px; }
  .rm-tabs-bar { overflow-x: auto; padding: 12px 16px 0; }
  .rm-tab { white-space: nowrap; }
}
</style>
